import { useCallback, useMemo } from 'react';
import { NavigateOptions, useNavigate } from 'react-router-dom';
import { useAccountId } from 'state';

export default function useNavigation(options?: NavigateOptions) {
    const accountId = useAccountId();
    const navigate = useNavigate();
    const accountUrl = useMemo(() => accountId ? `/accounts/${accountId}` : '', [accountId]);
    const navigateTo = useCallback((path: string) => navigate(`${accountUrl}/${path}`, options), [accountUrl, navigate, options]);

    return {
        deductionsUrl: `${accountUrl}/deductions`,
        disputesUrl: `${accountUrl}/disputes`,
        invoicesUrl: `${accountUrl}/invoices`,
        paymentsUrl: `${accountUrl}/payments`,
        searchUrl: `${accountUrl}/search`,
        navigateToCreateDispute: () => navigate('/createdispute', options),
        navigateToDispute: (disputeNumber: string) => navigate(`/disputes/${disputeNumber}`, options),
        navigateToDisputes: () => navigateTo('disputes'), 

        navigateToBillback: (accountId: string, vendorId: string, invoiceId: string) => navigate(
            `/accounts/${accountId}/vendors/${vendorId}/billback/${invoiceId}`,
            options
        ),
        navigateToRepay: (accountId: string, vendorId: string, invoiceId: string) => navigate(
            `/accounts/${accountId}/vendors/${vendorId}/repay/${invoiceId}`,
            options
        ),
        navigateToCredit: (accountId: string, vendorId: string, invoiceId: string) => navigate(
            `/accounts/${accountId}/vendors/${vendorId}/credit/${invoiceId}`,
            options
        ),
        
        navigateToDeduction: (accountId: string, vendorId: string, invoiceId: string, referenceId?: string) => navigate(
            `/accounts/${accountId}/vendors/${vendorId}/deductions/${invoiceId}${referenceId ? `?referenceId=${encodeURIComponent(referenceId)}` : ''}`,
            options
        ),
        navigateToDeductions: () => navigateTo('deductions'),
        navigateToInvoice: (accountId: string, vendorId: string, invoiceId: string) => navigate(
            `/accounts/${accountId}/vendors/${vendorId}/invoices/${invoiceId}`, 
            options
        ),
        navigateToInvoices: () => navigateTo('invoices'),
        navigateToPayment: (accountId: string, vendorId: string, paymentIdRef: string) => navigate(
            `/accounts/${accountId}/vendors/${vendorId}/payments/${paymentIdRef}`, 
            options
        ),
        navigateToPayments: () => navigateTo('payments'),
        navigateToSearch: () => navigateTo('search'),
        navigateToUploadInvoice: () => navigate('/uploadinvoice', options),
    };
}